import BackgroundTrimmer from './component';

export default BackgroundTrimmer;
